var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelMailFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  fill: "#FFF",
  rx: 2,
  transform: "translate(3 3)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  d: "M19.005 3C20.107 3 21 3.893 21 4.995v14.01A1.995 1.995 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.005V4.995C3 3.893 3.893 3 4.995 3Zm-8.411 9.27-3.738 2.516.001.063.006.11a1 1 0 0 0 1 .898h8.275l.11-.006c.503-.054.895-.48.895-1.002l.001-.102-.21-.14-1.363-.914-.372-.25c-.622-.417-1.246-.837-1.743-1.173l-.815.61-.089.04c-.288.096-.952.082-1.133-.04zM6.856 9.763v4.228l3.136-2.131zm10.286.009-3.09 2.088 3.09 2.12zm-1.004-1.63H7.862l-.116.007a1.004 1.004 0 0 0-.881.875l4.961 3.301.068.045c.139.091.161.076.34-.045l4.903-3.263.006.088c0-.557-.442-1.008-1.005-1.008"
}))));
export default SvgGemChannelMailFilled;